import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SeverityBadge } from "@/components/Primitives";
import { Repeat, Hammer } from "lucide-react";
import { toast } from "sonner";

const DIMS = ["", "asset", "user", "client", "category"];

export default function RecurringV2() {
  const [items, setItems] = useState([]);
  const [dim, setDim] = useState("");
  const [counts, setCounts] = useState(null);

  const load = (d) => api.get("/recurring/v2", { params: d ? { dimension: d } : {} }).then(r => setItems(r.data));
  useEffect(() => { load(dim); }, [dim]);

  const detect = async () => {
    const { data } = await api.post("/recurring/detect-v2");
    setCounts(data.by_dimension);
    toast.success(`Detected ${data.detected} cross-dimension patterns`);
    load(dim);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Recurring Issue Intelligence 2.0</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Cross-Dimension Patterns</h1>
          <p className="text-sm text-zinc-500 mt-1">Patterns across assets, users, clients, and categories.</p>
        </div>
        <button onClick={detect} data-testid="rv2-detect-btn" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md px-3 py-2"><Repeat size={14}/> Run detection</button>
      </div>

      {counts && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
          {Object.entries(counts).map(([k,v]) => (
            <div key={k} className="bg-zinc-950 border border-zinc-900 rounded px-3 py-2 text-sm">
              <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{k}</div>
              <div className="font-mono">{v}</div>
            </div>
          ))}
        </div>
      )}

      <div className="flex gap-2">
        {DIMS.map(d => (
          <button key={d || "all"} onClick={()=>setDim(d)} data-testid={`rv2-filter-${d || "all"}`} className={`text-xs rounded px-3 py-1.5 border ${dim===d?"bg-blue-600 text-white border-blue-600":"bg-zinc-950 border-zinc-800 text-zinc-300"}`}>{d || "all"}</button>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {items.map(r => (
          <div key={r.id} className="bg-zinc-950 border border-zinc-900 rounded-md p-4">
            <div className="flex items-center gap-2">
              <SeverityBadge level={r.severity}/>
              <div className="text-xs uppercase tracking-widest font-mono text-zinc-500">{r.dimension}</div>
              <div className="ml-auto text-emerald-400 font-mono text-sm">₱{r.estimated_cost_php.toLocaleString()}</div>
            </div>
            <div className="text-sm mt-2 font-mono text-zinc-200">{r.key}</div>
            <div className="text-[11px] text-zinc-500 font-mono mt-1">{r.occurrences} occurrences · {r.first_seen?.slice(0,10)} → {r.last_seen?.slice(0,10)}</div>
          </div>
        ))}
        {items.length === 0 && <div className="text-zinc-500 text-sm">Run detection to surface patterns.</div>}
      </div>
    </div>
  );
}
